import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Ensure these files exist in src/images
import winterCar from "../images/val-bg.png"; 
import truckImg from "../images/truck-van-img.png"; 

function Promotions() {
  const navigate = useNavigate();
  const [copiedCode, setCopiedCode] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(""), 2000);
  };

  return (
    <div className="w-full">
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            
            {/* FAMILY CAR CARD (Green) */}
            <div className="relative group overflow-hidden rounded-3xl bg-gradient-to-br from-[#006039] to-[#008a52] text-white p-10 min-h-[400px] shadow-xl transition-all hover:shadow-2xl">
              <div className="relative z-10 w-full md:w-3/5">
                <div className="flex gap-2 mb-4">
                  <span className="inline-block bg-white/20 backdrop-blur-md px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
                 Romantic Gateway
                  </span>
                  <span className="inline-block bg-[#ca8032] text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest">
                    Valid until Feb 14
                  </span>
                </div>

                <h3 className="text-4xl font-black mb-4 leading-tight">VALENTINE'S<br/>SPECIAL</h3>
                <p className="text-green-50/80 mb-6 text-sm">
                 Celebrate love on the open road. Get <span className="text-white font-bold">10% OFF</span> rentals with code:
                </p>
                <div className="inline-flex flex-wrap items-center gap-4">
                  <div 
                    onClick={() => handleCopy("VAL10")}
                    className="relative cursor-pointer bg-black/20 border border-white/30 rounded-lg px-4 py-2 font-mono font-bold text-xl hover:bg-black/30 transition-colors group/code"
                    title="Click to copy"
                  >
                    VAL10
                    {copiedCode === "VAL10" && (
                      <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-white text-[#006039] text-[10px] px-2 py-1 rounded shadow-md font-sans">
                        COPIED!
                      </span>
                    )}
                  </div>
                  <button 
                    onClick={() => navigate("/offers")}
                    className="bg-white text-[#006039] px-6 py-2 rounded-full font-bold text-sm hover:bg-[#ca8032] hover:text-white transition-all shadow-md"
                  >
                    Book Now
                  </button>
                </div>
              </div>
             <div className="absolute -right-10 -bottom-5 w-2/3 pointer-events-none group-hover:-translate-x-4 transition-transform duration-500">
  <img 
    src={winterCar} 
    alt="Family Car" 
    className="w-full h-auto drop-shadow-2xl" 
    style={{ 
      maskImage: 'linear-gradient(to right, transparent 0%, black 30%)',
      WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 30%)' 
    }}
  />
</div>
            </div>

            {/* TRUCK & VAN CARD (Orange #ca8032) */}
            <div className="relative group overflow-hidden rounded-3xl bg-gradient-to-br from-[#ca8032] to-[#b36d24] text-white p-10 min-h-[400px] shadow-xl transition-all hover:shadow-2xl">
              <div className="relative z-10 w-full md:w-3/5">
                <div className="flex gap-2 mb-4">
                  <span className="inline-block bg-black/20 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
                    Fleet Offer
                  </span>
                  <span className="inline-block bg-white text-[#ca8032] px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest">
                    Valid until Feb 15
                  </span>
                </div>

                <h3 className="text-4xl font-black mb-4 leading-tight">MOVE WITH<br/>CONFIDENCE</h3>
                <p className="text-white mb-6 text-sm opacity-90">
                Get <strong>15%  OFF</strong>  Your Next Move! Reliable trucks for your family projects or big transitions.
                </p>
                <div className="inline-flex flex-wrap items-center gap-4">
                  <div 
                    onClick={() => handleCopy("MOVE15")}
                    className="relative cursor-pointer bg-white/10 border border-white/30 rounded-lg px-4 py-2 font-mono font-bold text-xl text-white hover:bg-white/20 transition-colors group/code"
                    title="Click to copy"
                  >
                    MOVE15
                    {copiedCode === "MOVE15" && (
                      <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-white text-[#ca8032] text-[10px] px-2 py-1 rounded shadow-md font-sans">
                        COPIED!
                      </span>
                    )}
                  </div>
                  <button 
                    onClick={() => navigate("/offers")}
                    className="bg-[#006039] text-white px-6 py-2 rounded-full font-bold text-sm hover:bg-white hover:text-[#006039] transition-all shadow-md"
                  >
                    Book Now
                  </button>
                </div>
              </div>
              <div className="absolute -right-10 -bottom-5 w-2/3 pointer-events-none group-hover:-translate-x-4 transition-transform duration-500">
                <img src={truckImg} alt="Fleet Truck" className="w-full h-auto drop-shadow-2xl" />
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default Promotions;